import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/AuthCallback.css';

const AuthCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { login } = useAuth();
    const [error, setError] = useState(null);

    useEffect(() => {
        const token = searchParams.get('token');
        const errorParam = searchParams.get('error');

        if (errorParam) {
            setError('Authentication failed. Please try again.');
            setTimeout(() => navigate('/login'), 3000);
            return;
        }

        if (token) {
            try {
                // Decode JWT to get user info
                const payload = JSON.parse(atob(token.split('.')[1]));
                login(token, payload);
                navigate('/');
            } catch (err) {
                console.error('Token decode error:', err);
                setError('Invalid authentication token.');
                setTimeout(() => navigate('/login'), 3000);
            }
        } else {
            setError('No authentication token received.');
            setTimeout(() => navigate('/login'), 3000);
        }
    }, [searchParams, login, navigate]);

    return (
        <div className="auth-callback">
            <div className="callback-card">
                {error ? (
                    <>
                        <div className="callback-icon error">❌</div>
                        <h2>Authentication Error</h2>
                        <p>{error}</p>
                        <p className="redirect-text">Redirecting to login...</p>
                    </>
                ) : (
                    <>
                        <div className="callback-spinner"></div>
                        <h2>Authenticating...</h2>
                        <p>Please wait while we verify your credentials.</p>
                    </>
                )}
            </div>
        </div>
    );
};

export default AuthCallback;
